// Copyright 2022 mitchelleglon
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import React from "react";
import { Link } from "react-router-dom";

function HomeContent() {
  return (
    <div className="hero-content">
      <h1 className="hero-title">Hi, I'm Mitch</h1>
      <h2 className="hero-subtitle">Junior Full-Stack Web Developer</h2>

      <div className="hero-btn">
        <Link
          class="hero-btn-inner"
          to="about"
          style={{ textDecoration: "none" }}
        >
          Enter
        </Link>
      </div>
      <h3 className="hero-status">Actively seeking Junior Developer Roles</h3>
    </div>
  );
}

export default HomeContent;
